var scope_0 = require('/Users/purzelrakete/src/gitlab.com/purzelrakete/feld-web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/90619edea959b38905e89367636acdf0.js').default;
var scope_1 = require('/Users/purzelrakete/src/gitlab.com/purzelrakete/feld-web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/db05830caed1a0725f35d150b38251be.js').default;
var scope_2 = require('/Users/purzelrakete/src/gitlab.com/purzelrakete/feld-web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    